

















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class MemberInfo extends Vue {
  @Prop({required: true})
  memberNo!: string;
  @Prop({required: true})
  memberName!: string;
  @Prop({required: true})
  email!: string;
  @Prop({required: true})
  memberId!: string;
  @Prop({required: true})
  blacklisted!: boolean;
  @Prop({required: true})
  memberStatus!: 'WAITING' | 'ACTIVE' | 'FREEZE' | 'DORMANT' | 'PAUSED';

  private get showMemberStatus(){
    return this.memberStatus === 'FREEZE' || this.memberStatus === 'DORMANT'
  }

  private get memberStatusLabel(){
    return this.$t(`MEMBER_CRM_${this.memberStatus}`)
  }
}
